/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconCheckMark from '@telus-uds/palette-public-mobile/build/rn/icons/CheckMark'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    background: '#f9f2dd',
    checkMarkFocusColor: '#fefefc',
    checkMarkHeight: 24,
    checkMarkHoverColor: '#fefefc',
    checkMarkIcon: PaletteIconCheckMark,
    checkMarkSelectedColor: '#f9f2dd',
    checkMarkUnselectedColor: 'rgba(0, 0, 0, 0)',
    checkMarkWidth: 24,
    padding: 16
  }
}
export default theme
